module.exports = __webpack_public_path__ + "img/NielsKlim_Innhold1.69cf678a.jpg";